"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectVariation = exports.isParticipating = exports.getChosenVariation = exports.default = exports.assignVariation = void 0;
var getApi = function getApi() {
  return window.cxApi;
};
var hasExperimentAPI = function hasExperimentAPI() {
  return window && window.cxApi;
};
var withCxApi = function withCxApi(cb) {
  return function () {
    return !hasExperimentAPI() ? null : cb.apply(void 0, arguments);
  };
};
var getChosenVariation = withCxApi(function () {
  return getApi().getChosenVariation();
});
exports.getChosenVariation = getChosenVariation;
var isParticipating = withCxApi(function () {
  var variant = getChosenVariation();
  return variant !== getApi().NOT_PARTICIPATING && variant !== getApi().NO_CHOSEN_VARIATION;
});
exports.isParticipating = isParticipating;
var assignVariation = withCxApi(function () {
  return getApi().chooseVariation();
});
exports.assignVariation = assignVariation;
var selectVariation = withCxApi(function (variation, experiment) {
  return getApi().setChosenVariation(variation, experiment);
});
exports.selectVariation = selectVariation;
var _default = {
  getChosenVariation: getChosenVariation,
  isParticipating: isParticipating,
  assignVariation: assignVariation,
  selectVariation: selectVariation
};
exports.default = _default;
//# sourceMappingURL=ExperimentConnector.js.map